import React from 'react';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';

ChartJS.register(ArcElement, Tooltip, Legend);

export function DoughnutChart({ data }) {
  const labels = data?.map(country => country.countryName) || [];
  const counts = data?.map(country => country.count) || [];

  // Generate enough colors for all countries
  const generateColors = (count) => {
    const baseColors = [
      '#5191CD', '#B6BE34', '#F57F29', '#51195D',
      '#7F3C8D', '#11A579', '#3969AC', '#F2B701',
      '#E73F74', '#80BA5A', '#E68310', '#008695',
      '#CF1C90', '#F97B72', '#4B4B8F', '#A5AA99'
    ];

    const colors = [];
    for (let i = 0; i < count; i++) {
      colors.push(baseColors[i % baseColors.length]);
    }
    return colors;
  };

  const chartData = {
    labels: labels,
    datasets: [
      {
        label: 'Number of Users',
        data: counts,
        backgroundColor: generateColors(labels.length),
        borderColor: '#ffffff',
        borderWidth: 1,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'right',
        align: 'start',
        labels: {
          boxWidth: 12,
          padding: 10,
          font: {
            size: 10,
          },
          usePointStyle: true,
          generateLabels: (chart) => {
            const data = chart.data;
            if (data.labels.length && data.datasets.length) {
              return data.labels.map((label, i) => ({
                text: `${label} (${data.datasets[0].data[i]})`,
                fillStyle: data.datasets[0].backgroundColor[i],
                strokeStyle: data.datasets[0].borderColor,
                lineWidth: data.datasets[0].borderWidth,
                hidden: isNaN(data.datasets[0].data[i]) || chart.getDatasetMeta(0).data[i].hidden,
                index: i
              }));
            }
            return [];
          }
        },
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            const label = context.label || '';
            const value = context.raw || 0;
            const total = context.dataset.data.reduce((a, b) => a + b, 0);
            const percentage = Math.round((value / total) * 100);
            return `${label}: ${value} (${percentage}%)`;
          }
        }
      },
    },
    cutout: '60%',
  };

  return (
    <div style={{
      display: 'flex',
      height: '300px',
      gap: '20px',
      overflow: 'hidden'
    }}>
      <div style={{
        flex: 1,
        position: 'relative',
        minWidth: '60%'
      }}>
        <Doughnut
          data={chartData}
          options={{
            ...options,
            plugins: {
              ...options.plugins,
              legend: { display: false }
            }
          }}
        />
      </div>

      <div style={{
        flex: '0 0 200px',
        overflowY: 'auto',
        paddingRight: '10px',
        maxHeight: '100%'
      }}>
        {/* Custom scrollable legend */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(180px, 1fr))',
          gap: '8px'
        }}>
          {chartData.labels.map((label, index) => (
            <div key={index} style={{
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              fontSize: '12px'
            }}>
              <div style={{
                width: '12px',
                height: '12px',
                backgroundColor: chartData.datasets[0].backgroundColor[index],
                borderRadius: '50%',
                border: `1px solid ${chartData.datasets[0].borderColor}`
              }} />
              <span style={{
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis'
              }}>
                {label} ({chartData.datasets[0].data[index]})
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}